import styles from './styles.module.css';
import Image from '@/shared/components/Image/new';
import { formatAuthorNames } from '@/shared/functions/formatAthorNames'
import { EnVivo } from "@/shared/components/enVivo";

const ModuloDestacadoXL = (props) => {
    const MAIN_CROP = '2_1_1300x655';
    const SECONDARY_CROP = 'Vertical_360x425';
	
	const {
		url,
		title,
		author,
		summary,
		image,
		images,
		subtitle,
		relatedLilaNews,
		croppedImages,
		customClippings,
		metadata,
		selectedImageId = null
	} = props;

	let authorsList = []
    if (author != undefined && author?.length) {
		const authorName = formatAuthorNames(author[0].name);
		author.length > 1 ? author.slice(0, 2).map(element => {
			
            const elementName = formatAuthorNames(element.name);
            return authorsList.push(element.slug ? `<a href=/autor/${element.slug}>${elementName}</a>` : elementName)

        }) 
        
        : authorsList.push(author[0].slug ? `<a href=/autor/${author[0].slug}>${authorName}</a>` : authorName)
	}
    const parsedAuthors = authorsList.join(' - ');

	const manualClippingMobile = croppedImages && croppedImages.filter(el => el.id === "Mobile")?.[0]


	const manualClippingMobileUrl = `${manualClippingMobile?.url}` ?? null;


	const manualClippingDesktop = croppedImages && croppedImages.filter(el => el.id === "Desktop")?.[0]

	const defaultImage = `${process.env.NEXT_PUBLIC_IMAGE_DOMAIN}/img/default.png`;
	const parseImage = images?.filter(image => image?.id === MAIN_CROP)
	const imageUrl = images?.[0] && `${manualClippingDesktop ? manualClippingDesktop?.url : (parseImage && parseImage[0].url ? parseImage[0].url : null) }`
	const imageTitle = images?.[0] && images[0]?.title

	let imagenMobile = SECONDARY_CROP; //uso el cropeo que genera lila por defecto
	if ( manualClippingMobileUrl !== undefined && (manualClippingMobileUrl && manualClippingMobileUrl !== 'undefined')) {
		imagenMobile = manualClippingMobileUrl; //si hay recorte uso el recorte
	}
	
var hasBackground="";
if(props.__extra.hasBackground) {
	hasBackground=props.__extra.hasBackground;
	//console.log(props.__extra.hasBackground);
}

return (
	<div className={` ${styles["destacadaXL-parent"]}`}>
				<div className={` ${styles["destacadaXL-container"]}`}>
				<a href={url} className={styles["url-nota-container"]} />
				<div className={`img-container-v2`}>
					
					<Image
									src={!imageUrl ? defaultImage : imageUrl}
									alt={imageTitle}
									clipping={MAIN_CROP}
									width={1300}
									height={655}
									srcSet={{mobile: imagenMobile}}
									className={styles["img"]}
								/>
								
					{metadata && metadata.typeWeb && metadata.typeWeb === "live_blog" && <EnVivo extraClass={styles["envivo2"]} data-testid='envivo'/>}
				</div>		
					<div className={ !hasBackground ? `${styles["destacadaXL-container-text-mobile"]}` : `${styles["destacadaXL-container-text-mobile"]} ${styles["container-text-mobile-background"]}`}>
					{title != "" && <div className={`${styles["destacadaXL-mobile-title"]}`} dangerouslySetInnerHTML={{ __html: title }} />}
					{parsedAuthors != "" && <div className={`${styles["destacadaXL-mobile-author"]}` } dangerouslySetInnerHTML={{ __html: 'Por ' + parsedAuthors }} />}
					{summary != "" && <div className={`${styles["destacadaXL-mobile-summary"]}`} dangerouslySetInnerHTML={{ __html: summary }} />}
					
					</div>
				
					<div className={ !hasBackground ? `${styles["destacadaXL-container-text"]}` : `${styles["destacadaXL-container-text"]} ${styles["destacadaXL-container-text-background"]}`}>
					{title != "" && <h1 className={!hasBackground ? `${styles["destacadaXL-title"]}` : `${styles["destacadaXL-title"]} ${styles["title-background"]}`  } dangerouslySetInnerHTML={{ __html: title }} />}
					{summary != "" && <div className={!hasBackground ? `${styles["destacadaXL-summary"]}` : `${styles["destacadaXL-summary"]} ${styles["summary-background"]}`} dangerouslySetInnerHTML={{ __html: summary }} />}
					{parsedAuthors && <div className={!hasBackground ? `${styles["destacadaXL-author"]}` : `${styles["destacadaXL-author"]} ${styles["author-background"]}`} dangerouslySetInnerHTML={{ __html: 'Por ' + parsedAuthors }} />}
					</div>
				</div>
				
	</div>
)
}
export default ModuloDestacadoXL; 